import { Model } from './model';

export class StripeConnectAccount extends Model {
  id: string;
  requirements: {
    past_due: string[];
    currently_due: string[];
  };
}
